// Janelas de tempo para o filtro global "Período" (spec, seção 5). Todo
// cálculo é feito com granularidade de mês (mesmo grão de `mes_referencia`).
const MESES = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];

export type PeriodoFiltro =
  | 'ultimos12' | 'ultimos6' | 'ultimos3'
  | 'mesAtual' | 'mesAnterior'
  | 'trimestreAtual' | 'trimestreAnterior'
  | 'anoAtual' | 'anoAnterior'
  | 'historico';

export interface JanelaPeriodo {
  inicio: Date; // dia 1 do primeiro mês, incluso
  fim: Date;    // dia 1 do último mês, incluso
}

export function mesReferenciaParaData(mesRef: string | null | undefined): Date | null {
  if (!mesRef) return null;
  const [mes, anoStr] = mesRef.split('/');
  const idx = MESES.indexOf((mes || '').toUpperCase());
  const ano = Number(anoStr);
  if (idx === -1 || !ano) return null;
  return new Date(ano, idx, 1);
}

export function calcularJanelaPeriodo(periodo: PeriodoFiltro, hoje: Date): JanelaPeriodo | null {
  const ano = hoje.getFullYear();
  const mes = hoje.getMonth(); // 0-11
  const primeiroDiaMesAtual = new Date(ano, mes, 1);
  const nMesesAtras = (n: number) => new Date(ano, mes - (n - 1), 1);

  switch (periodo) {
    case 'ultimos12': return { inicio: nMesesAtras(12), fim: primeiroDiaMesAtual };
    case 'ultimos6': return { inicio: nMesesAtras(6), fim: primeiroDiaMesAtual };
    case 'ultimos3': return { inicio: nMesesAtras(3), fim: primeiroDiaMesAtual };
    case 'mesAtual': return { inicio: primeiroDiaMesAtual, fim: primeiroDiaMesAtual };
    case 'mesAnterior': { const d = new Date(ano, mes - 1, 1); return { inicio: d, fim: d }; }
    case 'trimestreAtual': { const inicioTri = new Date(ano, mes - (mes % 3), 1); return { inicio: inicioTri, fim: primeiroDiaMesAtual }; }
    case 'trimestreAnterior': {
      const inicioTriAtualMes = mes - (mes % 3);
      return { inicio: new Date(ano, inicioTriAtualMes - 3, 1), fim: new Date(ano, inicioTriAtualMes - 1, 1) };
    }
    case 'anoAtual': return { inicio: new Date(ano, 0, 1), fim: new Date(ano, 11, 1) };
    case 'anoAnterior': return { inicio: new Date(ano - 1, 0, 1), fim: new Date(ano - 1, 11, 1) };
    case 'historico': return null;
  }
}

export function mesRefNaJanela(mesRef: string | null | undefined, janela: JanelaPeriodo | null): boolean {
  const d = mesReferenciaParaData(mesRef);
  if (!d) return false;
  if (!janela) return true;
  return d.getTime() >= janela.inicio.getTime() && d.getTime() <= janela.fim.getTime();
}
